var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M512 256a256 256 0 0 1-512 0L256 0a256 256 0 0 1 256 256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M256 0A256 256 0 0 0 0 256h133.6v-75.2l75.2 75.2H256v-47.2l-75.2-75.2H256V0zm125.8 91.5l-11.3 35h-36.7l29.7 21.4-11.3 35 29.6-21.7 29.7 21.6L400 148l29.7-21.5H393l-11.3-34.9zm61.3 72.5l-11.3 35h-36.7l29.7 21.4-11.3 35 29.6-21.7 29.7 21.6-11.4-34.9 29.7-21.5h-36.7L443.1 164zm-122.8 10.3L309 209.2h-36.7l29.7 21.5-11.3 34.9 29.6-21.6 29.7 21.6-11.4-35 29.7-21.5h-36.7l-11.3-34.8zM379.4 304l-11.3 34.9h-36.7l29.7 21.5-11.3 34.9 29.6-21.6 29.7 21.6-11.4-35 29.7-21.5h-36.7L379.4 304z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M129.5 33.4a257.2 257.2 0 0 0-96.1 96.1V256h66.8V100.2H256V33.4H129.5zm252.3 83.4l-5.6 17.4h-18.4l14.9 10.8-5.7 17.4 14.8-10.8 14.9 10.8L391 145l14.8-10.8h-18.3l-5.7-17.4zm-248.2 16.8L256 256v-31.5l-91-91h-31.4zM443 189.3l-5.6 17.4H419l14.9 10.8-5.7 17.4 14.8-10.8 15 10.9-5.7-17.4 14.8-10.8h-18.3l-5.7-17.4zm-122.8 10.2l-5.6 17.5h-18.4l14.9 10.7-5.7 17.5 14.8-10.8 14.9 10.8-5.7-17.5 14.8-10.7H326l-5.7-17.5zm59.1 129.7l-5.6 17.5h-18.4l14.9 10.7-5.7 17.5 14.8-10.8 14.8 10.8-5.6-17.5 14.8-10.7H385l-5.7-17.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.dae91a79c981698e008d539a77ab576d.svg";
export { ForwardRef as ReactComponent };